import { render } from "./CGL.vue?vue&type=template&id=6b690e98"
import script from "./CGL.vue?vue&type=script&lang=js"
export * from "./CGL.vue?vue&type=script&lang=js"

import exportComponent from "/Users/jonathanthomas/Documents/Sites/vuejs/suivi-live/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__